module.exports = __webpack_public_path__ + "img/niu10.c8b1401f.jpg";